/** @format */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { Layout, Form, Col, Row, Typography } from 'antd'
import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons'

import InputField from '../../../components/Input'
import Button from '../../../components/Button'
import Images from '../../../components/Images'
import Spacer from '../../../components/Spacer'
import AuthSideBox from '../../../components/AuthSideBox'

import userRegister from './services'

import './style.css'

export default function Register(props) {
	const [loading, setLoading] = useState(false)

	const handleSubmitRegister = async (item) => {
		setLoading(true)
		let response = userRegister(item)
		setLoading(false)
		if (response) {
			props.history.push('/login')
		}
	}

	return (
		<Layout>
			<div className='ph-register-responsive-logo-container'>
				<Images
					classContent={'ph-register-responsive-logo'}
					webp={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.webp`}
					jp2={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.jp2`}
					jxr={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.jxr`}
					default={`${process.env.REACT_APP_STORAGE_IMAGES}/Logo-Pharol.png`}
					title={'Logo'}
				/>
				<Typography.Text className='ph-register-responsive-title'>Panel de Administración</Typography.Text>
			</div>
			<Layout.Content className='ph-register-main-container'>
				<Row className='ph-register-inner-container'>
					<Col span={24}>
						<Row>
							<Col xs={24} sm={10} md={9} lg={9} xl={8} className='ph-register-authside-container'>
								<AuthSideBox />
							</Col>
							<Col xs={24} sm={14} md={15} lg={15} xl={16}>
								<div className='ph-register-main-form-container'>
									<Row className='ph-register-main-form-inner-container'>
										<Col span={24}>
											<h2 className='ph-register-main-form-title'>Registro de Usuario</h2>
											<h3 className='ph-register-main-form-description'>
												Ingresa datos de registro...
											</h3>{' '}
											<Form
												className='ph-register-form-content'
												name='normal_register'
												initialValues={{ remember: true }}
												onFinish={handleSubmitRegister}>
												<InputField
													inputName={'first_name'}
													inputNameLabel={'Nombre'}
													inputNameRule={true}
													inputNameMessage={'Ingresa tu nombre'}
													inputNameType={'text'}
													inputNameIcon={<UserOutlined />}
													inputNameRules={[
														{
															required: true,
															message: 'Debe ingresar Nombre',
														},
													]}
												/>
												<InputField
													inputName={'last_name'}
													inputNameLabel={'Apellido'}
													inputNameRule={true}
													inputNameMessage={'Ingresa tu apellido'}
													inputNameType={'text'}
													inputNameIcon={<UserOutlined />}
													inputNameRules={[
														{
															required: true,
															message: 'Debe ingresar Apellido',
														},
													]}
												/>
												<InputField
													inputName={'email'}
													inputNameLabel={'Correo electrónico'}
													inputNameRule={true}
													inputNameMessage={'Ingresa tu correo'}
													inputNameType={'text'}
													inputNameIcon={<MailOutlined />}
													inputNameRules={'rulesEmail'}
												/>
												<InputField
													inputName={'password'}
													inputNameLabel={'Contraseña'}
													inputNameRule={true}
													inputNameMessage={'Ingresa tu contraseña'}
													inputNameType={'password'}
													inputNameIcon={<LockOutlined />}
													inputNameRules={'rulesPassword'}
												/>
												<Form.Item>
													<div className='ph-register-button-container'>
														<h3 className='ph-register-button-register-description'>
															¿Ya tienes cuenta?
															<Link to='/login'>
																<span className='ph-register-button-register-description-inner'>
																	Ingresa
																</span>
															</Link>
														</h3>
														<Spacer />
														<Button labelName={'Registrar'} loadingSubmit={loading} />
													</div>
												</Form.Item>
											</Form>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</Layout.Content>
		</Layout>
	)
}
